import { controlerAcces, type Verdict } from '../../../../../web-commun/connexion-google'
import { MOTIF_ACCES, resoudreOrganisation, seDeconnecter, type Acces } from './operations'

export interface DependancesEntree {
  resoudre: (profileId: string) => Promise<Acces>
  deconnecter: () => Promise<void>
}

/**
 * Contrôle d'accès commun à TOUTES les façons d'entrer (mot de passe, code WhatsApp, Google, session restaurée).
 *
 * Se connecter ne donne aucun droit : la personne doit être membre d'équipe ACTIF d'une organisation opératrice
 * (`resoudreOrganisation`). Sinon elle est déconnectée sur-le-champ. Pour une session ouverte par Google, le refus a
 * toujours la même phrase, quel que soit le motif (inconnu, livreur, suspendu…) : on ne dit rien du compte.
 */
export async function controlerEntree(
  profileId: string,
  viaGoogle: boolean,
  dep: DependancesEntree = { resoudre: resoudreOrganisation, deconnecter: seDeconnecter },
): Promise<Verdict<{ orgId: string; role: Extract<Acces, { ok: true }>['role'] }>> {
  return controlerAcces({
    viaGoogle,
    deconnecter: dep.deconnecter,
    evaluer: async () => {
      const a = await dep.resoudre(profileId)
      return a.ok ? { ok: true, acces: { orgId: a.orgId, role: a.role } } : { ok: false, message: MOTIF_ACCES[a.motif] }
    },
  })
}
